/**
 * Admin Layout
 * Main layout for admin dashboard with responsive navigation
 */

import { Outlet } from 'react-router-dom';
import { Sidebar } from '../navigation/Sidebar';
import { TopBar } from '../navigation/TopBar';
import { EnvironmentBadge } from '@/components/common/EnvironmentBadge';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { useMobileDrawer, useSidebar } from '@/stores/uiStore';
import { useIsDesktop, useIsTablet } from '@/hooks/useMediaQuery';

export function AdminLayout() {
  const { isMobileDrawerOpen, closeMobileDrawer, openMobileDrawer } = useMobileDrawer();
  const { isSidebarCollapsed } = useSidebar();
  const isDesktop = useIsDesktop();
  const isTablet = useIsTablet();

  return (
    <div className="flex h-screen overflow-hidden bg-[#eeeeee]">
        {isDesktop && (
          <aside>
            <Sidebar compact={isSidebarCollapsed} />
          </aside>
        )}

        {isTablet && (
          <aside>
            <Sidebar compact />
          </aside>
        )}

        <div className="flex flex-1 flex-col overflow-hidden">
          <TopBar onOpenMobileMenu={openMobileDrawer} />

          <main className="flex-1 overflow-y-auto px-4 py-4 sm:p-6">
            <Outlet />
          </main>
        </div>

        <Sheet open={isMobileDrawerOpen} onOpenChange={(open) => !open && closeMobileDrawer()}>
          <SheetContent side="left" className="w-[88vw] max-w-xs p-0">
            <Sidebar onNavigate={closeMobileDrawer} />
          </SheetContent>
        </Sheet>

        <EnvironmentBadge />
      </div>
  );
}
